<template>
    <div class="app-container">
        <el-form :inline="true" :model="filters">
            <el-form-item label="关键词">
                <el-input size="small" v-model="filters.search" placeholder="关键字"></el-input>
            </el-form-item>
            <el-form-item>
                <el-radio-group v-model="filters.isRedeem">
                    <el-radio :label="-1">全部</el-radio>
                    <el-radio :label="1">已兑</el-radio>
                    <el-radio :label="0">待兑</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" v-on:click="queryAll">查询</el-button>
                <el-button size="small" type="success" @click="handleCreate">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="mini" stripe border :data="tableData" highlight-current-row expand-on-click-node="false">
            <el-table-column prop="Code" label="中奖编号" width="130">
                <template slot-scope="scope">
                    <div>{{ scope.row.Code }}</div>
                    {{ format.dateTimeFormat(scope.row.WinningDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="Member.RealName" label="中奖人" width="150">
                <template slot-scope="scope">
                    <div>{{ scope.row.Member.RealName }}</div>
                    <div>{{ scope.row.Member.Mobile }}</div>
                    <div>{{ scope.row.Member.IdCode }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="Member.RealName" label="奖品信息" min-width="120">
                <template slot-scope="scope">
                    <div style="font-weight: bold;color:red;">价值：￥{{ scope.row.Award.Price }}</div>
                    <div>{{ scope.row.Award.Name }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="Award.Description" label="兑奖说明" min-width="150">
            </el-table-column>
            <el-table-column prop="QRCode" label="二维码" width="80">
                <template slot-scope="scope">
                    <viewer v-if="format.estimateIsImage(scope.row.QRCode)">
                        <img v-if="scope.row.QRCode" :src="baseUrl + scope.row.QRCode" :key="scope.row.QRCode"
                            style="height: 40px" />
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column prop="IsRedeem" label="是否已兑奖" width="100">
                <template slot-scope="scope">
                    <el-tag type="danger" v-if="scope.row.IsRedeem">是</el-tag>
                    <el-tag type="info" v-else>否</el-tag>
                    <div v-if="scope.row.IsRedeem"> {{ format.dateFormat(scope.row.RedeemDate) }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="Description" label="备注" min-width="80">
            </el-table-column>
            <el-table-column sortable prop="InsertTime" label="创建时间" width="100">
                <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.InsertTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" :current-page.sync="pageIndex"></el-pagination>
        </div>
        <memberAwardEditor ref="memberAwardEditor" @update="queryAll" />
    </div>
</template>
<script>
import { getPageList, del } from "@/api/activity/memberAward";
import memberAwardEditor from "./components/memberAwardEditor.vue";
export default {
    components: {
        memberAwardEditor,
    },
    data() {
        return {
            filters: {
                search: "",
                isRedeem: -1,
            },
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            pageSizesList: [10, 15, 20, 30, 50],
        };
    },
    methods: {
        queryAll() {
            let para = {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                search: this.filters.search,
                isRedeem: this.filters.isRedeem,
            };
            getPageList(para).then((response) => {
                if (response) {
                    this.tableData = response.Items;
                    this.total = response.Total || response.Items.length;
                }
            });
        },
        handleCreate() {
            this.$nextTick(() => {
                this.$refs["memberAwardEditor"].handleCreate();
            });
        },
        handleUpdate(row) {
            this.$nextTick(() => {
                this.$refs["memberAwardEditor"].handleUpdate(row);
            });
        },
        //删除
        handleDelete: function (row) {
            this.$confirm("确认删除中奖信息吗?", "提示", {
                type: "warning",
            }).then(() => {
                let para = { key: row.Key };
                del(para).then((response) => {
                    if (response) {
                        this.msg.successMsg("操作成功");
                        this.queryAll();
                    }
                });
            });
        },
        handleSizeChange(val) {
            var pageSize = `${val}`;
            this.pageIndex = 1;
            this.pageSize = parseInt(pageSize);
            this.$nextTick(() => this.queryAll());
        },

        handleCurrentChange(val) {
            this.pageIndex = `${val}`;
            this.queryAll();
        },
    },
    mounted() {
        this.queryAll();
    },
};
</script>